import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    faqGuidelineList: [],
    faqGuidelineCount: 0,
    categories: [],
};

const mutations = {
    [type.SET_FAQ_GUIDELINE_LIST](state, { data, count }) {
        state.faqGuidelineList = data;
        state.faqGuidelineCount = count;
    },

    [type.SET_FAQ_GUIDELINE_CATEGORIES](state, categories) {
        state.categories = categories;
    },

    [type.ADD_FAQ_GUIDELINE_CATEGORY](state, category) {
        state.categories.push(category);
    },

    // Replace a single row in place — used after an acknowledgement so the
    // Read/Unread pill updates without waiting on a refetch (PS-8898).
    [type.PATCH_FAQ_GUIDELINE](state, guideline) {
        if (!guideline) {
            return;
        }

        const index = state.faqGuidelineList.findIndex(
            g => g.id === guideline.id,
        );

        if (index !== -1) {
            state.faqGuidelineList.splice(index, 1, guideline);
        }
    },
};

const getters = {
    faqGuidelines(state) {
        return state.faqGuidelineList;
    },

    faqGuidelineCount(state) {
        return state.faqGuidelineCount;
    },

    faqGuidelineCategories(state) {
        return state.categories;
    },
};

const actions = {
    getFaqGuidelines({ commit, dispatch }, params = {}) {
        let route = Laroute.route('franchise.faq-guideline.index');
        startLoading(dispatch, 'fetch-faqGuidelines');

        return axios
            .get(route, { params })
            .then(res => {
                commit(type.SET_FAQ_GUIDELINE_LIST, {
                    data: res.data.data,
                    count: res.data.count,
                });
                endLoading(dispatch, 'fetch-faqGuidelines');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-faqGuidelines');
                throw err;
            });
    },

    getFaqGuideline({ dispatch }, id) {
        let route = Laroute.route('franchise.faq-guideline.show', { id });
        startLoading(dispatch, 'fetch-guideline');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-guideline');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-guideline');
                throw err;
            });
    },

    getFaqGuidelineCategories({ commit, state }) {
        if (state.categories.length) {
            return Promise.resolve(state.categories);
        }

        let route = Laroute.route('franchise.faq-guideline.categories');

        return axios.get(route).then(res => {
            commit(type.SET_FAQ_GUIDELINE_CATEGORIES, res.data);
            return res.data;
        });
    },

    createFaqGuidelineCategory({ commit, dispatch }, payload) {
        let route = Laroute.route('franchise.faq-guideline.categories.store');
        startLoading(dispatch, 'save-faq-guideline-category');

        return axios
            .post(route, payload)
            .then(res => {
                commit(type.ADD_FAQ_GUIDELINE_CATEGORY, res.data);
                endLoading(dispatch, 'save-faq-guideline-category');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'save-faq-guideline-category');
                throw err;
            });
    },

    createFaqGuideline({ dispatch }, payload) {
        let route = Laroute.route('franchise.faq-guideline.store');
        startLoading(dispatch, 'save-guideline');

        return axios
            .post(route, payload)
            .then(res => {
                endLoading(dispatch, 'save-guideline');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'save-guideline');
                throw err;
            });
    },

    updateFaqGuideline({ dispatch }, { id, payload }) {
        let route = Laroute.route('franchise.faq-guideline.update', { id });
        startLoading(dispatch, 'save-guideline');

        return axios
            .patch(route, payload)
            .then(res => {
                endLoading(dispatch, 'save-guideline');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'save-guideline');
                throw err;
            });
    },

    uploadFaqGuidelineMedia({ dispatch }, { id, formData }) {
        let route = Laroute.route('franchise.faq-guideline.media.store', {
            id,
        });
        startLoading(dispatch, 'save-guideline');

        return axios
            .post(route, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then(res => {
                endLoading(dispatch, 'save-guideline');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'save-guideline');
                throw err;
            });
    },

    acknowledgeFaqGuideline({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.faq-guideline.acknowledge', {
            id,
        });
        startLoading(dispatch, 'acknowledge-guideline');

        return axios
            .post(route)
            .then(res => {
                // Keep any list rendered from this module in sync immediately.
                commit(type.PATCH_FAQ_GUIDELINE, res.data);
                endLoading(dispatch, 'acknowledge-guideline');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'acknowledge-guideline');
                throw err;
            });
    },

    deleteFaqGuideline({ dispatch }, ids) {
        let route = Laroute.route('franchise.faq-guideline.delete');
        startLoading(dispatch, 'delete-guideline');

        return axios
            .delete(route, { data: { ids: [].concat(ids) } })
            .then(res => {
                endLoading(dispatch, 'delete-guideline');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'delete-guideline');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/faq-guideline.js